import AWS from 'aws-sdk';
// Threadheads
const accessKeyId = 'AKIA2UC3D3ZYFO5ZGMP3';
const secretAccessKey = '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';
AWS.config.update({
    region: 'ap-southeast-2',
    credentials: new AWS.Credentials(accessKeyId, secretAccessKey),
});
const s3 = new AWS.S3({ apiVersion: '2006-03-01' });
export default s3;
